module.exports = __webpack_public_path__ + "7e4b29ba/img/copy-icon.408fdb2d.svg";